import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { authRedirectReset } from '@/actions/AuthActionsTs';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { LoginPage } from '@/pages/login/Login/LoginPage';
import { isLogin as getIsLogin } from '@/utils/resources/auth/authResource';
import { myPagePath } from '@/utils/router/links';
export const Login = () => {
    const auth = useTypeSelector((state) => state.auth);
    const dispatch = useDispatch();
    // ログイン状態
    const isLogin = useMemo(() => getIsLogin(auth), [auth]);
    /** リダイレクト先 */
    const redirectPath = useMemo(() => auth.redirectPath || myPagePath(), [auth]);
    /**
     * ログイン時のリダイレクト リセット
     */
    const redirectReset = useCallback(() => {
        dispatch(authRedirectReset());
    }, [dispatch]);
    useEffect(() => () => {
        redirectReset();
    }, [redirectReset]);
    // 既にログイン済の場合
    if (isLogin) {
        return _jsx(CustomRedirect, { to: myPagePath() });
    }
    return _jsx(LoginPage, { redirectPath: redirectPath });
};
